export const reviews = "reviews";
export const reviewsWbJobLoadNew = "reviews:wb_load_new";
export const reviewsWbJobLoadOld = "reviews:wb_load_old";
export const reviewsWbJobSend = "reviews:wb_send";
export const reviewsWbJobApprove = "reviews:wb_approve";
export const reviewsWbJobReset = "reviews:wb_reset";
export const reviewsWbJobGenerate = "reviews:wb_generate";
export const reviewsOzonJobLoadNew = "reviews:ozon_load_new";
export const reviewsOzonJobLoadNewDaemon = "reviews:ozon_load_new_daemon";
export const reviewsOzonJobLoadNewDaemonEnsure =
  "reviews:ozon_load_new_daemon_ensure";
export const reviewsOzonJobLoadViewedAwaiting =
  "reviews:ozon_load_viewed_awaiting";
export const reviewsOzonJobLoadViewedDaily = "reviews:ozon_load_viewed_daily";
export const reviewsOzonJobLoadOld = "reviews:ozon_load_old";
export const reviewsOzonJobSend = "reviews:ozon_send";
export const reviewsOzonJobApprove = "reviews:ozon_approve";
export const reviewsOzonJobReset = "reviews:ozon_reset";
export const reviewsOzonJobGenerate = "reviews:ozon_generate";
export const reviewsYaJobLoadNew = "reviews:ya_load_new";
export const reviewsYaJobLoadOld = "reviews:ya_load_old";
export const reviewsYaJobSend = "reviews:ya_send";
export const reviewsYaJobApprove = "reviews:ya_approve";
export const reviewsYaJobReset = "reviews:ya_reset";
export const reviewsYaJobGenerate = "reviews:ya_generate";
export const reviewsJobReevaluateAutoReplies = "reviews:reevaluate_auto_replies";

export const products = "products";
export const productsOzonLoadProducts = "products:ozon_load_products";
export const productsWbLoadProducts = "products:wb_load_products";
export const productsMpCatalogSyncWb = "products:mp_catalog_sync_wb";
export const productsMpCatalogSyncOzon = "products:mp_catalog_sync_ozon";
export const productsMpProductSeedLinks = "products:mp_product_seed_links";
export const productsMpProductAutoMatch = "products:mp_product_auto_match";
export const productsWbClassifyCategoryBrand =
  "products:wb_classify_category_brand";

export const deliveriesWb = "deliveries_wb";
export const deliveriesWbUpdateSupplyCookie =
  "deliveries_wb:update_supply_cookie";
export const deliveriesWbPollSlots = "deliveries_wb:poll_slots";
export const deliveriesWbPollSlotsEnsure =
  "deliveries_wb:poll_slots_ensure";
export const deliveriesWbPlanSupply = "deliveries_wb:plan_supply";

export const wbSlots = "wb_slots";
export const wbSlotsEnsure = "wb_slots:ensure";

export const deliveriesOzon = "deliveries_ozon";
export const deliveriesOzonUpdateSupplyCookie =
  "deliveries_ozon:update_supply_cookie";

export const authTokens = "auth_tokens";
export const authTokensUpdateOzonCookie =
  "auth_tokens:update_ozon_cookie";

export const remnants = "stock_management";
export const remnantsComputeNewStock =
  "stock_management:compute_new_stock";
export const remnantsRemnantZeroingOut =
  "stock_management:remnant_zeroing_out";
export const remnantsOzonLoadWarehouseStocks =
  "stock_management:ozon_load_warehouse_stocks";
export const remnantsOzonLoadReserved =
  "stock_management:ozon_load_reserved";
export const remnantsOzonSendRemnants =
  "stock_management:ozon_send_remnants";

export const ozon = "ozon";
export const ozonJobSendPrices = "ozon:send_prices";
export const ozonJobLoadSales = "ozon:load_sales";

export const ya = "ya";
export const yaJobSendPrices = "ya:send_prices";
export const yaJobSendRemnants = "ya:send_remnants";
export const yaJobLoadReserved = "ya:load_reserved";
export const sberJobSendPrices = "sber:send_prices";
export const sberJobSendRemnants = "sber:send_remnants";
export const sberJobLoadReserved = "sber:load_reserved";
export const aliJobSendPrices = "ali:send_prices";
export const aliJobSendRemnants = "ali:send_remnants";
export const aliJobLoadReserved = "ali:load_reserved";
export const yaJobLoadSales = "ya:load_sales";
export const yaJobUpdateSk = "ya:update_sk";
export const aliJobUpdateProductCode = "ali:update_product_code";

export const productQuestions = "product_questions";
export const productQuestionsJobLoad = "product_questions:load";
export const productQuestionsJobSend = "product_questions:send";

export const fbsOrders = "fbs_orders";
export const fbsOrdersJobSyncHot = "fbs_orders:sync_hot";
export const fbsOrdersJobDayClose = "fbs_orders:day_close";
export const fbsOrdersJobEnrichSupplies = "fbs_orders:enrich_supplies";
